export const nullNoop = () => null;
